enum MouvementActionType {
	DELETE = 'DELETE',
	UPDATE = 'UPDATE',
	UPDATE_MOUVEMENT = 'UPDATE_MOUVEMENT',
	DUPLIQUER = 'DUPLIQUER',
	SHOW_MOUVEMENT = 'SHOW_MOUVEMENT',
	ANNULER = 'ANNULER',
	REJETER = 'REJETER',
}

export default MouvementActionType;
